module.exports = __webpack_public_path__ + "img/ladrillos-eu.3a5cfc86.png";